import { FontOption } from '../data/typography'

interface FontLoadRequest {
  font: FontOption
  weight: number
}

export const buildGoogleFontsUrl = (requests: FontLoadRequest[]): string | null => {
  const families = new Map<string, Set<number>>()

  requests.forEach(({ font, weight }) => {
    if (!font.googleFamily) return
    if (!families.has(font.googleFamily)) {
      families.set(font.googleFamily, new Set())
    }
    families.get(font.googleFamily)!.add(weight)
  })

  if (families.size === 0) return null

  const familyParams = Array.from(families.entries()).map(([family, weights]) => {
    const weightList = Array.from(weights).sort((a, b) => a - b).join(';')
    const familyName = family.replace(/ /g, '+')
    return `family=${familyName}:wght@${weightList}`
  })

  return `https://fonts.googleapis.com/css2?${familyParams.join('&')}&display=swap`
}
